import { ServiceProviderError } from '@takeshape/errors';
import curry from 'lodash/curry.js';
import { providers } from "./providers/index.js";
import { isOpenAPIServiceProvider } from "./types.js";
export { default as providers } from "./providers/index.js";
export { isAIModelType, isOAuth2ServerAuthentication, isOpenIdConfiguration, isServiceFormData } from "./types.js";
export { getOAuth2ClientCredentialsDefaults } from "./util/auth-info.js";
export { getInitialData } from "./util/initial-data.js";
function isProviderKey(key) {
    return key in providers;
}
export const nameList = Object.values(providers).map((provider) => provider.name);
export const typeList = [...new Set(Object.values(providers).map((provider) => provider.serviceType))];
export function getServiceProvider(key) {
    return isProviderKey(key) ? providers[key] : undefined;
}
export function getOpenAPIServiceProvider(key) {
    const provider = isProviderKey(key) && providers[key];
    return provider && isOpenAPIServiceProvider(provider) ? provider : undefined;
}
export const findServiceProvider = curry((serviceType, name) => {
    const found = Object.values(providers).find((provider) => serviceType.includes(provider.serviceType) && provider.name === name);
    if (!found) {
        throw new ServiceProviderError('Invalid provider selection');
    }
    return found;
});
export const findAuthenticationServiceProvider = (name) => {
    return findServiceProvider('authentication', name);
};
export const findGraphQLServiceProvider = (name) => {
    return findServiceProvider('graphql', name);
};
export const findRESTServiceProvider = (name) => {
    return findServiceProvider('rest', name);
};
export const findOpenAPIServiceProvider = (name) => {
    return findServiceProvider('openapi', name);
};
export const findAPIServiceProvider = (name) => {
    return findServiceProvider(['graphql', 'rest', 'openapi'], name);
};
export const findDeploymentServiceProvider = findServiceProvider('deployment');
